import React from 'react';
import { HomeMenuCategoryWithFoods, FoodDetailItem, listRestaurantType } from '../../../../../interfaces/types';
import FoodItem from './FoodItem';
import { isPreOrderDisabled } from '../../../../../utils/preOrderDisabled';
import { GameDayData } from '../../../../../utils/timeSlots';

interface FoodListProps {
  category: HomeMenuCategoryWithFoods | undefined;
  activeFood: { [key: string]: number };
  getRestaurantName: (restaurantId: string) => string;
  onFoodClick: (food: FoodDetailItem, categoryId: string) => void;
  onSetCount: (newCount: number, itemId: string, categoryId: string) => void;
  onDeleteClick?: (foodId: string, categoryId: string) => void;
  /** Pass listRestaurantData to enable pre-order disable logic */
  listRestaurantData?: listRestaurantType[];
  /** The game/order date in ISO format (for acceptance window check) */
  orderDate?: string | null;
  /** Whether current session is pre-order */
  isPreOrder?: boolean;
  deliveryRequest?: string;
  gameDayData?: GameDayData | null;
}

const FoodList: React.FC<FoodListProps> = ({
  category,
  activeFood,
  getRestaurantName,
  onFoodClick,
  onSetCount,
  onDeleteClick,
  listRestaurantData,
  orderDate,
  isPreOrder,
  deliveryRequest,
  gameDayData,
}) => {
  if (!category || !category.foods || category.foods.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-4 pb-6">
      {category.foods.map((food) => {
        const foodKey = `${food.id}_${category.id}`;
        const hasFoodInCart = !!activeFood[foodKey];
        const quantity = activeFood[foodKey] || 0;
        const restaurantName = food.restaurantId ? getRestaurantName(food.restaurantId) : '';

        const restaurant = listRestaurantData?.find((r) => r.id === food.restaurantId);
        const preOrderStatus = isPreOrderDisabled(food, restaurant, orderDate, isPreOrder ?? false, deliveryRequest, gameDayData);

        return (
          <FoodItem
            key={food.id}
            food={food}
            categoryId={category.id}
            hasFoodInCart={hasFoodInCart}
            quantity={quantity}
            restaurantName={restaurantName}
            onFoodClick={onFoodClick}
            onSetCount={onSetCount}
            onDeleteClick={onDeleteClick}
            preOrderStatus={preOrderStatus}
          />
        );
      })}
    </div>
  );
};

export default FoodList;
